import { FF_C4C_VOICE_CALL } from '@/constants/featureFlags';
import { useFeatureFlags } from '@/hooks';
import { useSavePatientTelecomAttributes } from '@/hooks/telecom/useSavePatientTelecomAttributes';
import { Logger } from '@/utils/logger';
import type { CallPatientButtonProps } from '@montugroup/clinic-telecom';
import { CallPatientButton } from '@montugroup/clinic-telecom';
import { Card, Grid, styled, Typography } from '@mui/material';

const logger = new Logger('ContactPatient');
const StyledCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(4),
  border: `1px solid ${theme.palette.primary.main}`
}));

export type ContactPatientProps = Pick<CallPatientButtonProps, 'patientId' | 'patientPhoneNumber' | 'patientName'>;

export const ContactPatient = ({ patientId, patientPhoneNumber, patientName }: ContactPatientProps) => {
  const { mutateAsync: savePatientTelecomAttributes } = useSavePatientTelecomAttributes(Number(patientId));
  const { flags } = useFeatureFlags();
  const isVoiceCallEnabled = flags[FF_C4C_VOICE_CALL];
  const handleContact = async (contact: connect.Contact) => {
    try {
      await savePatientTelecomAttributes(contact.contactId);
    } catch (error) {
      logger.error('Failed to save patient telecom attributes', error);
    }
  };

  if (!isVoiceCallEnabled) {
    return null;
  }

  return (
    <Grid item xs={12} lg={12}>
      <StyledCard>
        <Typography component="h2" variant="subtitle2" color="primary">
          Contact Patient
        </Typography>
        <CallPatientButton
          patientId={patientId}
          patientPhoneNumber={patientPhoneNumber}
          onContact={handleContact}
          patientName={patientName}
          variant="large"
        />
      </StyledCard>
    </Grid>
  );
};
